import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from 'react-bootstrap';
import { ICONS } from 'Utils/icons';
import { getTopics } from './ChatbotAxiosFuncs';
import { STATUSES, ERROR_MESSAGES } from "Utils/constants";
import { setGlobalErrorStatus } from 'Components/StatusHandling';

const ChatbotTopicDropdown = ({
  chatbotInfoStorage,
  setChatbotInfoStorage,
  resetChatbotChannel
}) => {

  const dispatch = useDispatch();

  const [isExpanded, setIsExpanded] = useState(false);
  const [topic, setTopic] = useState({ timePeriodId: -1, desc: <><b>Selected</b>: All</> });
  const [topicList, setTopicList] = useState([]);

  const handleDropdownbyKey = (e, isExp) => {
    // Enter key code: 13
    if (e.keyCode == 13) {
      setIsExpanded(!isExp);
    }
  }

  const handleTopicChange = (t) => {
    setTopic({
      //...t,
      timePeriodId: t.timePeriodId,
      desc: <><b>Selected</b>: {t.desc}</>
    });
    setIsExpanded(false);

    //set topic and reset memory
    let newChatbotInfoStorage = {
      ...chatbotInfoStorage,
      topicId: t.timePeriodId
    }

    if (t.timePeriodId != chatbotInfoStorage.topicId) {
      newChatbotInfoStorage = {
        ...newChatbotInfoStorage,
        resetMemory: true
      }
    }

    localStorage.setItem("chatbot_info_storage", JSON.stringify({
      ...newChatbotInfoStorage
    }));

    setChatbotInfoStorage({
      ...newChatbotInfoStorage,
    });

    resetChatbotChannel.postMessage({
      ...newChatbotInfoStorage
    });
  }

  const handleTopicChangeByKey = (e, t) => {
    // Enter key code: 13
    if (e.keyCode == 13) {
      handleTopicChange(t);
    }
  }

  // init 
  useEffect(() => {
    // load topic list
    getTopics().then((res) => {
      //console.log("getTopics in useEffect", res);
      var statusCode = res.data.status;
      if (statusCode < 0) {
        statusCode = STATUSES.ERROR.code;
      }
      switch (statusCode) {
        case STATUSES.ERROR.code:
          if (res.data.globalErrorMessageList && res.data.globalErrorMessageList.length != 0) {
            setGlobalErrorStatus({
              dispatch: dispatch,
              popupData: {
                visible: true,
                title: ERROR_MESSAGES.GENERAL_ERROR.title,
                msg: res.data.globalErrorMessageList,
                showContactHelp: false
              },
              redirect: {
                redirect: false,
                redirectFirst: false,
                path: "",
                data: {}
              }
            })
          };
          break;
        case STATUSES.SUCCESS.code:
          // set topic list
          let list = res.data.data;
          setTopicList(list);
          // get local storage topic id if there is
          const storage = JSON.parse(localStorage.getItem('chatbot_info_storage'));
          // setTopic
          //if (storage.topicId) {
          for (let i = 0; i < list.length; i++) {

            let item = list[i];
            if (item.timePeriodId === storage.topicId) {
              setTopic({
                timePeriodId: item.timePeriodId,
                desc: <><b>Selected</b>: {item.desc}</>
              })
            }
          }
          //}
          break;
      }
    }).catch(function (error) {
      setGlobalErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: ERROR_MESSAGES.DATA_ERROR.title,
          msg: ERROR_MESSAGES.DATA_ERROR.message,
          showContactHelp: true
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        },
        error: error
      });
    });
  }, [chatbotInfoStorage.topicId]);

const handleBlur = (event) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      if (isExpanded) {
        setIsExpanded(false);
      }
    }
  }

  return (
    <span onBlur={(event) => {handleBlur(event)}}>
      <Button
        className="d-flex justify-content-between align-items-center topic-dropdown-btn w-100"
        onClick={() => setIsExpanded(!isExpanded)}
        onKeyDown={(e) => handleDropdownbyKey(e, isExpanded)}
      >
        <div>{topic?.desc}</div>
        {isExpanded ?
          <div className='me-3'>
            <ICONS.upArrow size={16}></ICONS.upArrow>
          </div> :
          <div className='me-3'>
            <ICONS.downArrow size={16}></ICONS.downArrow>
          </div>}
      </Button>
      {isExpanded ?
        <div className='topic-dropdown-list'>
          <div className='text-start ms-3 mt-2 p-2'>
            Select a specific Common Format to narrow down your focus and get a more accurate answer.
          </div>
          {topicList?.map((t, index) => {
            return (
              <div className='ms-3 me-2 p-2 topic-dropdown-item'>
                <Button
                  className='text-start topic-dropdown-item-btn m-0 p-0 w-100'
                  key={t.timePeriodId}
                  onClick={() => { handleTopicChange(t) }}
                  onKeyDown={(e) => { handleTopicChangeByKey(e, t) }}
                >
                  {t.desc}
                </Button>
              </div>
            )
          })}
        </div>
        : null
      }
    </span>
  )
}

export default ChatbotTopicDropdown;